import { useId } from 'react';

import type {
  RatingsDisplayProps,
  RatingItemProps,
  RatingIndicatorProps,
} from './RatingsDisplay.types';
import { useTranslation } from 'react-i18next';

export const RatingsDisplay = ({ ratings }: RatingsDisplayProps) => {
  const { t } = useTranslation('analysis');

  return (
    <div className="flex flex-col gap-4">
      <RatingItem
        label={t('strategicTerritoriesWidget.ratingsDisplay.strategicAlignment')}
        value={ratings.strategicAlignment}
      />
      <RatingItem
        label={t('strategicTerritoriesWidget.ratingsDisplay.breakthroughPotential')}
        value={ratings.breakthroughPotential}
      />
      <RatingItem
        label={t('strategicTerritoriesWidget.ratingsDisplay.inspirationalPotential')}
        value={ratings.inspirationalPotential}
      />
    </div>
  );
};

const RatingItem = ({ label, value }: RatingItemProps) => {
  const labelId = useId();

  return (
    <div className="flex items-center justify-between">
      <span id={labelId} className="text-body-sm text-foreground">
        {label}
      </span>
      {/* The dots are the only carrier of the score, so the meter role and the
          label association are what let a screen reader read it at all. */}
      <RatingIndicator filled={value} labelledBy={labelId} />
    </div>
  );
};

const RatingIndicator = ({ filled, total = 5, labelledBy }: RatingIndicatorProps) => {
  return (
    <div
      className="flex gap-1"
      role="meter"
      aria-labelledby={labelledBy}
      aria-valuenow={filled}
      aria-valuemin={0}
      aria-valuemax={total}
    >
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          aria-hidden
          className={`size-4 rounded-full ${index < filled ? 'bg-primary' : 'bg-muted'}`}
        />
      ))}
    </div>
  );
};
